import { map, filter } from 'ramda';
import {
  splitConversationId, getAgentWebResource, isGroup, jsonParser, parseApiMessage, isMessage,
} from '@twnel/utils-js/web';

// Como api.messages.get de @twnel/utils-js, pero acotado a un rango de fechas (ms). Los chats lo
// filtran en el backend (start/end, paginado por número de página); los canales (rooms) solo
// admiten `before`, así que la primera página empieza en el final del rango y las siguientes en
// el mensaje más antiguo recibido.
const MessagesRange = (http, { MESSAGES }) => ({
  company, conversation, start, end, pageMarker, perPage = 100,
}) => {
  let headers;
  let requestUrl;
  if (isGroup(conversation)) {
    const before = pageMarker ?? (Number.isFinite(end) ? end + 1 : Date.now());
    requestUrl = `${MESSAGES}/rooms/${encodeURIComponent(conversation.id)}`
      + `/messages?limit=${perPage}&before=${before}`;
  } else {
    const {
      id, host, agent, resource,
    } = splitConversationId(conversation);
    let conversationId = `${id}@${host}`;
    if (agent && resource) {
      conversationId += `/${getAgentWebResource(id, agent)}`;
      headers = { agent: getAgentWebResource(company.id, resource) };
    }
    requestUrl = `${MESSAGES}?with=${encodeURIComponent(conversationId)}`
      + `&per_page=${perPage}&page=${pageMarker ?? 1}`;
    if (Number.isFinite(start)) {
      requestUrl += `&start=${start}`;
    }
    if (Number.isFinite(end)) {
      requestUrl += `&end=${end}`;
    }
  }

  return http.get(requestUrl, { headers })
    .then(jsonParser)
    .then(map(parseApiMessage))
    .then((parsedMessages) => ({
      complete: parsedMessages.length < perPage,
      messages: filter(isMessage, parsedMessages),
    }));
};

export default MessagesRange;
